import { OEButton, flex, mr } from '@openeducation/oe-it-components';
import { arrayParseDate } from '@openeducation/oe-it-services';
import { styled } from '@openeducation/oe-it-themes';
import { format } from 'date-fns';
import React, { useState } from 'react';

import { Banner } from '../../atoms/banner/banner';
import { useJoinClass } from '../../hooks/use-join-class';
import { ActiveClass } from '../../interfaces/active-class';
import { RequestAssistanceForm } from '../../organisms/request-assistance-form/request-assistance-form';

export interface RejoinBannerProps {
  rejoinClass: ActiveClass;
}

export const RejoinBanner = ({ rejoinClass }: RejoinBannerProps) => {
  const { joinClass } = useJoinClass({
    url: rejoinClass?.link,
  });

  const [showRequestAssistanceMessage, setShowRequestAssistanceMessage] =
    useState(false);

  const parsedDate = arrayParseDate(rejoinClass.classBegin);
  const classTime = parsedDate ? format(parsedDate, 'h:mm a') : '';

  return (
    <>
      <BannerContainer
        innerStyle={flex('flex-column')}
        title="Classroom Rejoin"
        message={`${classTime} classroom '${rejoinClass.title}'`}
        type="info"
        actions={
          <>
            <OEButton
              style={mr(8)}
              type="danger"
              size="small"
              onPress={() => setShowRequestAssistanceMessage(true)}
            >
              Assistance
            </OEButton>

            <OEButton type="accent" size="small" onPress={joinClass}>
              Rejoin class
            </OEButton>
          </>
        }
      />
      <RequestAssistanceForm
        visible={showRequestAssistanceMessage}
        onClose={() => setShowRequestAssistanceMessage(false)}
        url={rejoinClass?.link}
      />
    </>
  );
};

const BannerContainer = styled(Banner)`
  margin: -32px;
  width: calc(100% + 64px);
  margin-bottom: 22px;
  flex-direction: row;
`;
